import organization       from '@/pages/organization'
import organizationView       from '@/pages/organization/view'
import organizationGiasStats       from '@/pages/organization/orgGiasStats'
import organizationMgr       from '@/pages/organization/orgMgr'
import allOrgStats       from '@/pages/organization/allOrgStats'
export default [
    {
        path: '/organization-list', 
        name: 'organization',
        component: organization,
    },
    {
        path: '/organization-view', 
        name: 'organizationView',
        component: organizationView,
    },
    {
        path: '/organization-giasStats', 
        name: 'organizationGiasStats',
        component: organizationGiasStats,
    },  
    {
        path: '/organizationMgr', 
        name: 'organizationMgr',
        component: organizationMgr,
    },  
    {
        path: '/allOrgStats', 
        name: 'allOrgStats',
        component: allOrgStats,
    }
]
